export default __webpack_public_path__ + "static/media/logo.101cd756.svg";